import Login from '@/components/auth/Login.vue';

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: '/tienda/:slug',
    name: 'tienda-publica',
    component: () => import('@/views/TiendaPublica.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/admin',
    component: () => import('@/layout/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/layout/AppHome.vue'),
      },
      {
        path: 'clientes',
        name: 'clientes',
        component: () => import('@/views/Clientes.vue'),
        meta: { roles: ['SUPER_ADMIN'] },
      },
      {
        path: 'agentes',
        name: 'agentes',
        component: () => import('@/views/Agentes.vue'),
      },
      {
        path: 'agentes/:id',
        name: 'agente-detalle',
        component: () => import('@/views/AgenteDetalle.vue'),
      },
      {
        path: 'pipeline',
        name: 'pipeline',
        component: () => import('@/views/Pipeline.vue'),
      },
      {
        path: 'contactos',
        name: 'contactos',
        component: () => import('@/views/Contactos.vue'),
      },
      {
        path: 'herramientas',
        name: 'herramientas',
        component: () => import('@/views/Herramientas.vue'),
      },
      {
        path: 'conversaciones',
        name: 'conversaciones',
        component: () => import('@/views/Conversaciones.vue'),
      },
      {
        path: 'calificacion',
        name: 'calificacion',
        component: () => import('@/views/Calificacion.vue'),
      },
      {
        path: 'remarketing',
        name: 'remarketing',
        component: () => import('@/views/Remarketing.vue'),
      },
      {
        path: 'redes-sociales',
        name: 'redes-sociales',
        component: () => import('@/views/RedesSociales.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE'] },
      },
      {
        path: 'configuracion',
        name: 'configuracion',
        component: () => import('@/views/Configuracion.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE'] },
      },
      {
        path: 'plantillas',
        name: 'plantillas',
        component: () => import('@/views/Plantillas.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE'] },
      },
      {
        path: 'flows',
        name: 'flows',
        component: () => import('@/views/Flows.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE'] },
      },
      {
        path: 'reportes',
        name: 'reportes',
        component: () => import('@/views/Reportes.vue'),
      },
      {
        path: 'agentes-humanos',
        name: 'agentes-humanos',
        component: () => import('@/views/AgentesHumanos.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE'] },
      },
      {
        path: 'mis-conversaciones',
        name: 'mis-conversaciones',
        component: () => import('@/views/MisConversaciones.vue'),
        meta: { roles: ['AGENTE_HUMANO'] },
      },
      {
        path: 'oportunidades',
        name: 'oportunidades',
        component: () => import('@/views/Oportunidades.vue'),
      },
      {
        path: 'catalogo',
        name: 'catalogo',
        component: () => import('@/views/Catalogo.vue'),
      },
      {
        path: 'recursos',
        name: 'recursos',
        component: () => import('@/views/Recursos.vue'),
      },
      {
        path: 'soporte',
        name: 'soporte',
        component: () => import('@/views/Soporte.vue'),
      },
      {
        path: 'reservaciones',
        name: 'reservaciones',
        component: () => import('@/views/Reservaciones.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE', 'COLABORADOR'] },
      },
      {
        path: 'tienda-online',
        name: 'tienda-online',
        component: () => import('@/views/TiendaOnline.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE', 'COLABORADOR'] },
      },
      {
        path: 'pedidos',
        name: 'pedidos',
        component: () => import('@/views/Pedidos.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE', 'COLABORADOR'] },
      },
      {
        path: 'sucursales',
        name: 'sucursales',
        component: () => import('@/views/Sucursales.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE'] },
      },
      {
        path: 'sucursales/:id',
        name: 'sucursal-detalle',
        component: () => import('@/views/SucursalDetalle.vue'),
        meta: { roles: ['SUPER_ADMIN', 'ADMIN_CLIENTE'] },
      },
      {
        path: 'mis-citas',
        name: 'mis-citas',
        component: () => import('@/views/MisCitas.vue'),
        meta: { roles: ['AGENTE_HUMANO'] },
      },
      {
        path: 'mi-cuenta',
        name: 'mi-cuenta',
        component: () => import('@/views/MiCuenta.vue'),
      },
    ],
  },
  {
    path: '/404',
    name: 'not-found',
    component: () => import('@/layout/AppNotFound.vue'),
  },
  {
    path: '/403',
    name: 'forbidden',
    component: () => import('@/layout/AppForbidden.vue'),
  },
  {
    path: '*',
    redirect: '/404',
  },
];

export default routes;
